import _classCallCheck from "/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Feature } from '../Feature.mjs';
var id = 0;
var ExitAnimationFeature = /*#__PURE__*/function (_Feature) {
  _inherits(ExitAnimationFeature, _Feature);
  var _super = _createSuper(ExitAnimationFeature);
  function ExitAnimationFeature() {
    var _this;
    _classCallCheck(this, ExitAnimationFeature);
    _this = _super.apply(this, arguments);
    _this.id = id++;
    return _this;
  }
  _createClass(ExitAnimationFeature, [{
    key: "update",
    value: function update() {
      var _this2 = this;
      if (!this.node.presenceContext) return;
      var _this$node$presenceCo = this.node.presenceContext,
        isPresent = _this$node$presenceCo.isPresent,
        onExitComplete = _this$node$presenceCo.onExitComplete,
        custom = _this$node$presenceCo.custom;
      var _ref = this.node.prevPresenceContext || {},
        prevIsPresent = _ref.isPresent;
      if (!this.node.animationState || isPresent === prevIsPresent) {
        return;
      }
      var exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
        custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
      });
      if (onExitComplete && !isPresent) {
        exitAnimation.then(function () {
          return onExitComplete(_this2.id);
        });
      }
    }
  }, {
    key: "mount",
    value: function mount() {
      var _ref2 = this.node.presenceContext || {},
        register = _ref2.register;
      if (register) {
        this.unmount = register(this.id);
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);
  return ExitAnimationFeature;
}(Feature);
export { ExitAnimationFeature };